module.exports = __webpack_public_path__ + "img/thumb-008-01.09bf438c.png";